import React from 'react';
import { JcColumn } from '../JcBox';
import { JcNotice, JcNoticeSeverity } from '../JcNotice';
import { JcButton, JcButtonType } from '../button/JcButton';
import { JcDataError, JcDataErrorCategory } from '../../data/JcDataError';
import { JcCommonProps } from '../../utils/JcUtils';

export interface JcDataErrorNoticeProps extends JcCommonProps {
    readonly error: JcDataError;
    readonly onRetry: () => void;
}

const messageFor = (category: JcDataErrorCategory): string => {
    switch (category) {
        case JcDataErrorCategory.PERMISSION:
            return "You don't have access to this. Try signing in, or check back later.";
        case JcDataErrorCategory.TRANSIENT:
            return 'Connection problem — this data could not be loaded.';
        default:
            return 'Something went wrong loading this data.';
    }
};

/**
 * Inline, in-context notice for a {@link JcDataError} — keeps surrounding page
 * chrome mounted. Offers Retry for retryable (transient) errors.
 */
export const JcDataErrorNotice = ({ error, onRetry, ...commonProps }: JcDataErrorNoticeProps): React.ReactElement => (
    <JcColumn {...commonProps} spacing>
        <JcNotice message={messageFor(error.category)} severity={JcNoticeSeverity.ERROR} />
        {error.retryable && (
            <JcButton buttonType={JcButtonType.PRIMARY} onClick={onRetry}>
                Retry
            </JcButton>
        )}
    </JcColumn>
);
